import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from 'react-redux';
import logoauthentek from "../../assets/images/logo-authentek-sm.png";
import logo from "../../UserAssets/images/authenteklogo.png"
import { useTranslation } from "react-i18next";
import { fetchPoweredByLogo } from '../../Redux/Api/fetch.api';


const Footer = () => {
	const { t } = useTranslation("dashboard");
	const allCompanysitedata = useSelector((state) => state.allDashboardReducer.companysite);
	const ResellerCompanyLogo = allCompanysitedata && allCompanysitedata.resellerCompanyLogo;
	const [companyLogo, setCompanyLogo] = useState("");

	useEffect(() => {
		getPoweredByCompanyLogo();
	}, [])

	const getPoweredByCompanyLogo = () => {		
		fetchPoweredByLogo()		
			.then(response => {				
				if (response.data.success) {
					setCompanyLogo(response.data.data)
				}
			})
			.catch((err) => {
				console.log("Err: ", err);
			})
	}
	return (
		<div className="footer-section mt-3 w-100">
			<div className="inner-footer">
				<div className="footer--logo justify-content-between align-items-center row">
					<div className="col-sm-5 align-items-center">
						{t("providedBy")} <img src={ResellerCompanyLogo} alt="Company Logo" className="small-logo" />
					</div>
					<div className="col-sm-6 center-text text-end">
						<div className="footer--logo">{t("poweredBy")} <a href="https://authentek.io/" target="_blank"><img src={companyLogo}></img> </a></div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Footer
